import React from 'react';
import {Box, Typography} from '@emburse/ui-core';

export interface SwitchTypographyProps {
    dataQA?: string;
    value?: string;
}

export const SwitchTypography = (props: SwitchTypographyProps) => {
    return (
        <Box className="switchLeftMargin">
            <Typography variant="body1" data-qa={props.dataQA}>{props.value}</Typography>
        </Box>
    );
};